function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 44V0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
  fill: "#FF5670"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.7929 15.7929C26.4024 16.1834 26.4024 16.8165 26.7929 17.2071C27.1834 17.5976 27.8166 17.5976 28.2071 17.2071L35.6667 9.74751L35.6667 14.6666C35.6667 15.2189 36.1144 15.6666 36.6667 15.6666C37.2189 15.6666 37.6667 15.2189 37.6667 14.6666L37.6667 7.33325C37.6667 7.19011 37.6366 7.05399 37.5824 6.93087C37.5429 6.84099 37.4896 6.75572 37.4224 6.67833C37.3892 6.64004 37.3531 6.60431 37.3145 6.57145C37.2462 6.51328 37.172 6.46576 37.094 6.4289C36.9644 6.36756 36.8196 6.33325 36.6667 6.33325L29.3333 6.33325C28.781 6.33325 28.3333 6.78097 28.3333 7.33325C28.3333 7.88554 28.781 8.33325 29.3333 8.33325L34.2525 8.33325L26.7929 15.7929Z",
  fill: "#FF5670"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.16667 8.83337C8.59203 8.83337 8.04093 9.06165 7.6346 9.46798C7.23775 9.86482 7.01075 10.3998 7.00037 10.9599C7.424 17.7267 10.3031 24.1068 15.0982 28.9019C19.8932 33.6969 26.2734 36.576 33.0402 36.9997C33.6003 36.9893 34.1352 36.7623 34.5321 36.3654C34.9384 35.9591 35.1667 35.408 35.1667 34.8334V28.5156L28.129 25.7005L26.0362 29.1884C25.6346 29.8579 24.7867 30.1073 24.0865 29.762C19.8093 27.6525 16.3475 24.1908 14.238 19.9135C13.8927 19.2134 14.1422 18.3654 14.8116 17.9638L18.2995 15.871L15.4844 8.83337H9.16667ZM5.51328 7.34666C6.48222 6.37772 7.79638 5.83337 9.16667 5.83337H16.5C17.1134 5.83337 17.6649 6.2068 17.8927 6.77629L21.5594 15.943C21.8328 16.6265 21.5697 17.4075 20.9384 17.7863L17.5834 19.7993C19.1913 22.531 21.4691 24.8087 24.2008 26.4166L26.2138 23.0616C26.5925 22.4303 27.3735 22.1672 28.0571 22.4407L37.2237 26.1073C37.7932 26.3351 38.1667 26.8867 38.1667 27.5V34.8334C38.1667 36.2037 37.6223 37.5178 36.6534 38.4868C35.6844 39.4557 34.3703 40 33 40C32.9696 40 32.9393 39.9991 32.909 39.9973C25.392 39.5405 18.302 36.3483 12.9769 31.0232C7.6517 25.698 4.45958 18.6081 4.00276 11.091C4.00092 11.0607 4 11.0304 4 11C4 9.62976 4.54434 8.31559 5.51328 7.34666Z",
  fill: "#0E185B"
});

var SvgPhoneCall = function SvgPhoneCall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneCall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone-call.0ea71695.svg";
export { ForwardRef as ReactComponent };